// @flow
import * as React from 'react';
import { type RouterHistory } from 'react-router-dom';
import BusyIndicator from '../Common/BusyIndicator';
import ForgottenPasswordPageDisplay from './ForgottenPasswordPageDisplay';
import NotificationModal from '../Modals/NotificationModal';
import api from '../../services/api';
import withModal from '../withModal';

class ForgottenPasswordPage extends React.PureComponent<
  {
    history: RouterHistory
  },
  {
    emailAddress: string,
    errors: Array<string>,
    busy: boolean
  }
> {
  state = {
    emailAddress: '',
    errors: [],
    busy: false
  };

  handleChange = (event: SyntheticKeyboardEvent<HTMLInputElement>): void => {
    this.setState({ emailAddress: event.currentTarget.value });
  };

  handleCancel = () => {
    this.props.history.goBack();
  };

  handleSubmit = (event: SyntheticEvent<HTMLButtonElement>) => {
    event.preventDefault();

    const { emailAddress } = this.state;

    if (emailAddress.length === 0) {
      this.setState({ errors: ['Please enter an email address'] });
      return;
    }

    this.setState({ busy: true }, () => {
      api.auth
        .resetPassword(emailAddress)
        .then(() => {
          this.props.showModal(NotificationModal, {
            kind: 'success',
            icon: 'check-circle',
            title: 'Password Reset',
            message: `An email has been sent to ${emailAddress}, please check your inbox for further instructions.`,
            onRequestClose: () => {
              this.props.history.goBack();
              this.props.hideModal();
            }
          });
        })
        .catch(errors => this.setState({ errors, busy: false }));
    });
  };

  render() {
    if (this.state.busy) {
      return <BusyIndicator size="5x" />;
    }

    return (
      <ForgottenPasswordPageDisplay
        emailAddress={this.state.emailAddress}
        errors={this.state.errors}
        onChange={this.handleChange}
        onCancel={this.handleCancel}
        onSubmit={this.handleSubmit}
      />
    );
  }
}

export default withModal(ForgottenPasswordPage);
